function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { styled } from '@airwallex/theme';
import { radius, space } from '@airwallex/global';
import Button from '@airwallex/button';
import { TextLink } from '@airwallex/typography';
export var ContentContainer = styled.div(function (_ref) {
  var _objectSpread2;

  var theme = _ref.theme,
      compact = _ref.compact;
  return _objectSpread((_objectSpread2 = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }, _defineProperty(_objectSpread2, '&& > * + *', {
    marginTop: theme.space.xs
  }), _defineProperty(_objectSpread2, "paddingTop", theme.space.xxs), _defineProperty(_objectSpread2, "paddingBottom", theme.space.xxs), _objectSpread2), compact && {
    paddingTop: 0,
    paddingBottom: 0
  });
});
export var AlertStyle = styled.div(function (_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant,
      compact = _ref2.compact,
      _ref2$layout = _ref2.layout,
      layout = _ref2$layout === void 0 ? 'default' : _ref2$layout;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    display: 'grid',
    position: 'relative',
    textAlign: 'left',
    gridGap: theme.space.s,
    padding: theme.space.s,
    fontSize: 14,
    borderRadius: radius.l,
    background: theme.alert.background.color.success
  }, variant === 'SUCCESS' && {
    background: theme.alert.background.color.success
  }), variant === 'INFORMATIONAL' && {
    background: theme.alert.background.color.informational
  }), variant === 'WARNING' && {
    background: theme.alert.background.color.warning
  }), variant === 'CRITICAL' && {
    background: theme.alert.background.color.critical
  }), layout === 'default' && {
    gridTemplateColumns: 'auto 1fr'
  }), compact && {
    alignItems: 'center',
    padding: "12px ".concat(theme.space.s)
  }), layout === 'withDismiss' && {
    gridTemplateColumns: 'auto 1fr auto',
    padding: theme.space.s,
    button: {
      alignSelf: 'start',
      marginTop: "-".concat(theme.space.xs),
      marginRight: "-".concat(theme.space.xs)
    }
  }), layout === 'withDismiss' && compact && {
    padding: "".concat(theme.space.xs, " ").concat(theme.space.s),
    gridTemplateColumns: 'auto 1fr auto',
    paddingRight: theme.space.xs,
    button: {
      alignSelf: 'center'
    }
  }), layout === 'withAction' && _defineProperty({
    gridTemplateColumns: 'auto 1fr auto'
  }, theme.breakpoints.breakpoint.s, {
    gridTemplateColumns: 'auto 1fr'
  })), layout === 'withAction' && compact && _defineProperty({
    padding: "".concat(theme.space.xs, " ").concat(theme.space.s),
    paddingRight: theme.space.xs
  }, theme.breakpoints.breakpoint.s, {
    padding: theme.space.s,
    gridTemplateColumns: 'auto 1fr'
  })), layout === 'withLinkAction' && _defineProperty({
    gridTemplateColumns: 'auto 1fr auto'
  }, theme.breakpoints.breakpoint.s, {
    gridTemplateColumns: 'auto 1fr'
  }));
});
export var AlertIconStyle = styled.div(function (_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    display: 'flex'
  }, variant === 'SUCCESS' && {
    color: theme.alert.icon.background.color.success
  }), variant === 'INFORMATIONAL' && {
    color: theme.alert.icon.background.color.informational
  }), variant === 'WARNING' && {
    color: theme.alert.icon.background.color.warning
  }), variant === 'CRITICAL' && {
    color: theme.alert.icon.background.color.critical
  });
});
export var ActionContainer = styled.div(function (_ref7) {
  var theme = _ref7.theme,
      compact = _ref7.compact,
      _ref7$layout = _ref7.layout,
      layout = _ref7$layout === void 0 ? 'default' : _ref7$layout;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_defineProperty({
    display: 'flex',
    alignItems: 'center'
  }, theme.breakpoints.breakpoint.s, {
    gridColumnEnd: 'span 2'
  }), layout === 'default' && {
    margin: 0
  }), layout === 'withLinkAction' && _defineProperty({}, theme.breakpoints.breakpoint.s, {
    gridColumnEnd: 'none'
  })), layout === 'withAction' && {
    marginLeft: theme.space.m,
    marginRight: theme.space.xs
  }), layout === 'withAction' && compact && {
    margin: 0
  });
});
var SharedButtonShadow = 'inset 0 1px 0 0 rgb(255 255 255 / 50%), 0 1px 0 0 rgb(0 0 0 / 2%)';
export var ActionButton = styled(Button)(function (_ref9) {
  var _ref10;

  var theme = _ref9.theme;
  return _ref10 = {
    padding: "".concat(theme.space.xs, " ").concat(theme.space.s),
    boxShadow: SharedButtonShadow,
    border: "1px solid ".concat(theme.alert.button.border.color),
    color: theme.alert.button.color
  }, _defineProperty(_ref10, '&:active, &:hover, &:focus', {
    background: theme.alert.button.hover.background.color,
    color: theme.alert.button.color,
    boxShadow: 'none'
  }), _defineProperty(_ref10, theme.breakpoints.breakpoint.s, {
    width: '100%'
  }), _ref10;
});
export var CloseButton = styled(Button)(function (_ref11) {
  var _ref12;

  var theme = _ref11.theme;
  return _ref12 = {
    padding: theme.space.xs,
    minWidth: 'auto',
    minHeight: 'auto',
    border: "1px solid transparent"
  }, _defineProperty(_ref12, '&:active, &:hover, &:focus', {
    boxShadow: SharedButtonShadow,
    border: "1px solid ".concat(theme.alert.button.border.color),
    background: theme.alert.button.hover.background.color,
    svg: {
      color: theme.alert.button.color
    }
  }), _defineProperty(_ref12, "svg", {
    color: theme.alert.button.color
  }), _ref12;
});
export var AlertTextLinkStyles = styled(TextLink)(function (_ref13) {
  var theme = _ref13.theme;
  return {
    textDecoration: 'underline',
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textUnderlineOffset: '2px',
    color: theme.alert.link.color,
    paddingLeft: space.xxs,
    paddingRight: space.xxs,
    textDecorationColor: theme.alert.link.textDecorationColor,
    ':hover': {
      textDecorationColor: theme.alert.link.hover.textDecorationColor
    },
    ':active': {
      color: theme.alert.link.active.color,
      textDecorationColor: theme.alert.link.active.textDecorationColor
    },
    ':focus': {
      outline: theme.alert.link.focus.outline
    }
  };
});